import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex-none h-[27px] min-w-[32px]" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "mb-[3px]" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "my-2"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 1,
  class: "my-2"
}
const _hoisted_9 = ["innerHTML"]

import { ref, onMounted } from 'vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { replaceBookmark } from '@/utils/bookmark.replace';

enum paymentMethodIds {
  bpay = 'bpay',
  australiaPost = 'australiaPost',
  phone = 'phone',
  creditCardOrCheque = 'creditCardOrCheque',
  inPerson = 'inPerson',
  payOnline = 'payOnline',
}

const paymentReferenceNumberName = 'paymentReferenceNumber';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentMethods',
  props: {
    paymentMethods: {},
    paymentReferenceNumber: {},
    bpayBillerCode: {},
    showAdditionalContent: { type: Boolean },
    filterPaymentMethods: { type: Boolean },
    bindSuccessful: { type: Boolean }
  },
  setup(__props: any) {

const filteredPaymentMethods = ref<any[]>([]);

const props = __props;

const showReferenceNumber = [paymentMethodIds.bpay, paymentMethodIds.payOnline];
const showBillerCode = [paymentMethodIds.bpay];

onMounted(async () => {
  filteredPaymentMethods.value = props.paymentMethods.filter(
    (x) =>
      !props.filterPaymentMethods ||
      x.fields?.methodId?.value !== paymentMethodIds.payOnline ||
      (x.fields?.methodId?.value === paymentMethodIds.payOnline && props.bindSuccessful)
  );
});

const replaceBookmarks = (content: string) => {
  if (props?.paymentReferenceNumber) {
    return replaceBookmark(paymentReferenceNumberName, content, props.paymentReferenceNumber);
  }
  return content;
};

const showPaymentReferenceNumber = (paymentMethodId: string) => {
  return showReferenceNumber.findIndex((x) => x === paymentMethodId) > -1 && props.paymentReferenceNumber;
};

const showBPAYBillerCode = (paymentMethodId: string) => {
  return showBillerCode.findIndex((x) => x === paymentMethodId) > -1;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPaymentMethods.value, (method, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["gap-4 flex flex-row", index < filteredPaymentMethods.value.length - 1 ? 'pb-3 mb-2' : ''])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: method.fields?.icon?.value?.src,
          alt: method.fields.icon?.value.alt,
          class: "mx-auto"
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(RichText), {
            field: { value: replaceBookmarks(method.fields?.methodTitle?.value) }
          }, null, 8, ["field"])
        ]),
        (_ctx.showAdditionalContent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(RichText), {
                  field: { value: replaceBookmarks(method.fields?.methodContent?.value) }
                }, null, 8, ["field"])
              ]),
              (showBPAYBillerCode(method.fields?.methodId?.value))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_ctx.bpayBillerCode)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "inline-flex items-center rounded-lg bg-racq-anti-flash-white py-2 px-4 text-sm text-racq-dark-grey ring-1 ring-inset ring-gray-500/10",
                          innerHTML: _ctx.bpayBillerCode
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (showPaymentReferenceNumber(method.fields?.methodId?.value))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_ctx.paymentReferenceNumber)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "inline-flex items-center rounded-lg bg-racq-anti-flash-white py-2 px-4 text-sm text-racq-dark-grey ring-1 ring-inset ring-gray-500/10",
                          innerHTML: _ctx.paymentReferenceNumber
                        }, null, 8, _hoisted_9))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2))
  }), 128))
}
}

})